(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-product-results-grid-2"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function highlightSelectedFilter() {
      const urlParams = new URLSearchParams(window.location.search);
      const selectedFilter = urlParams.get('type');
      if (selectedFilter) {
        const selectedPanel = document.querySelector(`.sq-filter-panel[data-filter="${selectedFilter}"]`);
        if (selectedPanel) {
          selectedPanel.classList.add('highlight');
        }
      }
    }

    window.onload = highlightSelectedFilter;

    document.querySelectorAll('.sq-filter-panel').forEach((panel) => {
      panel.addEventListener('click', () => {
        const filter = panel.getAttribute('data-filter');
        const url = new URL(window.location);
        url.searchParams.set('type', filter);
        window.location.href = url;
      });
    });

    let productsHtml = '';
    const filteredProductGrid = document.getElementById('product-grid');
    const yourVehicleDiv = document.getElementById('your-vehicle');
    const urlParams = new URLSearchParams(window.location.search);
    const idsParam = urlParams.get('ids');
    const typeFilter = urlParams.get('type');
    console.log(typeFilter);
    let productIds = [];
    if (idsParam) {
      const idArray = idsParam.split(',');
      productIds = idArray.map((id) => `gid://shopify/Product/${id}`);
    }
    const shopifyDomain = 'https://6288b9-3.myshopify.com';
    const storefrontAccessToken = '45d9b4629d70da03a8645bab57da4e3e';
    function getCurrencySymbol(currencyCode) {
      const currencySymbols = {
        USD: '$',
        EUR: '€',
        GBP: '£',
      };
      return currencySymbols[currencyCode] || currencyCode;
    }

    // Fetch product data
    const query = `
        query($ids: [ID!]!) {
        nodes(ids: $ids) {
        ... on Product {
        id
        title
        handle
        productType
        vendor
        tags
        images(first: 1) {
        edges {
        node {
        id
        altText
        url(transform:{maxWidth: 400})
        }
        }
        }
        variants(first: 1) {
        edges {
        node {
        id
        title
        sku
        price{
        amount
        currencyCode
        }
        quantityAvailable
        }
        }
        }
        }
        }
        }
        `;

    fetch(`${shopifyDomain}/api/2023-04/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
      },
      body: JSON.stringify({
        query,
        variables: {
          ids: productIds,
        },
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        const sortedProducts = data.data.nodes.sort((a, b) => {
          const aStock = a.variants.edges[0].node.quantityAvailable > 0 ? 1 : 0;
          const bStock = b.variants.edges[0].node.quantityAvailable > 0 ? 1 : 0;
          // console.log('Sorted By Stock');
          return bStock - aStock;
        });

        sortedProducts.forEach((product) => {
          let includeProduct = true;
          const productId = product.id;
          const productTitle = product.title;
          const productSku = product.handle;
          const productType = product.productType;
          const productVendor = product.vendor;
          const productImage = product.images.edges[0].node.url
            ? product.images.edges[0].node.url
            : 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?format=jpg&quality=90&v=1530129081';
          const bladeSize = product.blade_size ? product.blade_size.value : '';
          const productLink = `/products/${product.handle}`;

          const filterMappings = {
            fixed_point: ['Fitment Type__Fix point', 'Fitment Type_Fix point'],
            flush_rails: ['Fitment Type__Flush Rails', 'Fitment Type_Flush Rails'],
            normal: ['Fitment Type__Normal Roof', 'Fitment Type_Normal Roof'],
            raised_rails: ['Fitment Type__Railing', 'Fitment Type_Railing'],
          };

          const mappedFilters = filterMappings[typeFilter] || [];
          console.log('Mapped Filters: ' + mappedFilters);
          console.log('Product Tags: ' + product.tags);

          const productTags = product.tags;

          if (mappedFilters.length > 0) {
            const anyMappedFilterIncluded = mappedFilters.some((mappedFilter) => productTags.includes(mappedFilter));
            if (!anyMappedFilterIncluded) {
              includeProduct = false;
            }
          }

          console.log('Include Product: ' + includeProduct);

          product.variants.edges.forEach((variantEdge) => {
            const variant = variantEdge.node;
            const originalPrice = variant.price.amount;
            const currencyCode = variant.price.currencyCode;
            const currencySymbol = getCurrencySymbol(currencyCode);
            const variantID = variant.id;
            const variantIdShort = variantID.substring(29);
            const quantityAvailable = variant.quantityAvailable;
            //check if variant is available and set a variable to use in the if statement
            const variantAvailable = quantityAvailable > 0 ? true : false;

            // You will need to ensure these product properties are correctly assigned from your product data
            const productPrice = originalPrice;
            let stockLevelText = quantityAvailable > 0 ? 'In stock' : 'Out of stock';
            let stockLevelClass =
              quantityAvailable === 0
                ? 'product-stock-level--none'
                : quantityAvailable > 0 && quantityAvailable < 6
                ? 'product-stock-level--low'
                : 'product-stock-level--high';
            let showAddToCart = quantityAvailable > 0 ? '' : 'style="display:none"';
            // Construct HTML for each product
            if (includeProduct) {
              productsHtml += `
            <div class="productgrid--item imagestyle--natural productitem--emphasis show-actions--mobile" data-product-item="" data-product-quickshop-url="${productLink}" style="--open-height: 526.2187728881836px;">
              <div class="productitem" data-product-item-content="" data-animation-state="closed">
                <div class="productitem__container">
                  <div class="productitem__image-container">
                    <a class="productitem--image-link" href="${productLink}" tabindex="-1">
                      <figure class="productitem--image" style="--product-grid-item-image-aspect-ratio: 1.0;">
                        <img src="${productImage}" alt="${productTitle}" class="productitem--image-primary">
                        <span class="visually-hidden">${productTitle}</span>
                      </figure>
                    </a>
                  </div>
                  <div class="productitem--info">
                    <div class="price productitem__price ">
                      <span class="money" data-price="">${currencySymbol}${productPrice}</span>
                    </div>
                    <h2 class="productitem--title">
                      <a href="${productLink}">${productTitle}</a>
                    </h2>
                    <span class="productitem--vendor">
                      <a href="/collections/vendors?q=${productVendor}" title="${productVendor}">${productVendor}</a>
                    </span>
                    <div class="product-stock-level-wrapper">

                      <span class="
                          product-stock-level
                          ${stockLevelClass} 
                          ">
                          <span class="product-stock-level__text">
                            <div class="product-stock-level__badge-text">
                              ${stockLevelText}
                            </div>
                          </span>
                      </span>
                    </div>
                  </div>
                  <product-form ${showAddToCart}>
                      <form method="post" action="/cart/add" id="quick-add-template--${variantIdShort}__product-grid" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                        <input type="hidden" name="form_type" value="product">
                        <input type="hidden" name="utf8" value="✓">
                        <input type="hidden" name="id" value="${variantIdShort}">
                        <button class="productitem--action-trigger productitem--action-atc button-primary" type="submit" aria-label="Add to cart">
                          <span class="atc-button--text">Add to cart</span>
                        </button>
                      </form>
                  </product-form>

                </div>
                <script type="application/json" data-quick-buy-settings="">
                  {
                    "cart_redirection": true,
                    "money_format": "${currencySymbol}${productPrice}"
                  }
                </script>
              </div>
            </div>
            `;
            }
          });
        });
        if (productsHtml === '') {
          productsHtml = `
            <div class="loading-overlay gradient"></div>
            <div class="title-wrapper center">
              <h2 class="title title--primary">Sorry we have no parts to fit your vehicle</h2>
            </div>
          `;
        }
        filteredProductGrid.innerHTML = productsHtml;

        //check if regResult is in local storage and if so set the variables below
        if (localStorage.getItem('regResult') !== null) {
          const yourVehicleJSON = localStorage.getItem('regResult');
          const yourVehicle = JSON.parse(yourVehicleJSON);
          const yourReg = yourVehicle.reg;
          const yourMake = yourVehicle.make;
          const yourModel = yourVehicle.model;
          const yourBody = yourVehicle.body;
          const yourFuel = yourVehicle.fuel_type;

          const yourVehicleHTML = `<div class="inner">
            <h1>Your vehicle</h1>
            <div class="icon-reg">
                <div class="your-vehicle__icon">
                    <img src=https://cdn.shopify.com/s/files/1/0715/0823/0446/files/hatchback.png?v=1682352677" alt="" srcset="">
                </div>
                <div class="your-vehicle__reg">${yourReg}</div>
            </div>
            <div class="your-vehicle__details">
              <h3>${yourMake} ${yourModel} ${yourBody}</h3>
            </div>
            <div class="your-vehicle__buttons vehicle-confirm__buttons">
                <a href="/pages/find-roof-bars" class="button button--primary">Change my vehicle</a>
            </div>
        </div>`;
          yourVehicleDiv.innerHTML = yourVehicleHTML;
        } else if (localStorage.getItem('manual_selected_options') !== null) {
          const yourVehicleJSON = localStorage.getItem('manual_selected_options');
          const yourVehicle = JSON.parse(yourVehicleJSON);
          const yourMake = yourVehicle.make;
          const yourModel = yourVehicle.model;
          const yourBody = yourVehicle.bodyStyle;
          const yourDateRange = yourVehicle.dateRange;
          let yourFuel = '';

          if (yourVehicle.fuelType !== '0') {
            yourFuel = yourVehicle.fuelType;
          }
          const yourVehicleHTML = `<div class="inner">
            <h1>Your vehicle</h1>
            <div class="icon-reg">
                <div class="your-vehicle__icon">
                    <img src=https://cdn.shopify.com/s/files/1/0715/0823/0446/files/hatchback.png?v=1682352677" alt="" srcset="">
                </div>
            </div>
            <div class="your-vehicle__details">
                <h3>${yourMake} ${yourModel} ${yourBody} </h3>
                <h3>${yourDateRange}</h3>
                <h3>${yourFuel}</h3>
            </div>
            <div class="your-vehicle__buttons vehicle-confirm__buttons">
                <a href="/pages/find-roof-bars" class="button button--primary">Change my vehicle</a>
            </div>
        </div>`;
          yourVehicleDiv.innerHTML = yourVehicleHTML;
        }
      })
      .catch((error) => {
        console.error('Error fetching products:', error);
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-results-grid"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
function highlightSelectedFilter() {
const urlParams = new URLSearchParams(window.location.search);
const selectedFilter = urlParams.get('type');
if (selectedFilter) {
const selectedPanel = document.querySelector(`.sq-filter-panel[data-filter="${selectedFilter}"]`);
if (selectedPanel) {
selectedPanel.classList.add('highlight');
}
}
}

window.onload = highlightSelectedFilter;

document.querySelectorAll('.sq-filter-panel').forEach((panel) => {
panel.addEventListener('click', () => {
const filter = panel.getAttribute('data-filter');
const url = new URL(window.location);
url.searchParams.set('type', filter);
window.location.href = url;
});
});

let productsHtml = '';
const filteredProductGrid = document.getElementById('product-grid');
const yourVehicleDiv = document.getElementById('your-vehicle');
const urlParams = new URLSearchParams(window.location.search);
const idsParam = urlParams.get('ids');
const typeFilter = urlParams.get('type');
console.log(typeFilter);
let productIds = [];
if (idsParam) {
const idArray = idsParam.split(',');
productIds = idArray.map((id) => `gid://shopify/Product/${id}`);
}
const shopifyDomain = 'https://6288b9-3.myshopify.com';
const storefrontAccessToken = '45d9b4629d70da03a8645bab57da4e3e';
function getCurrencySymbol(currencyCode) {
const currencySymbols = {
USD: '$',
EUR: '€',
GBP: '£',
};
return currencySymbols[currencyCode] || currencyCode;
}

// Fetch product data
const query = `
query($ids: [ID!]!) {
nodes(ids: $ids) {
... on Product {
id
title
handle
productType
vendor
tags
images(first: 1) {
edges {
node {
id
altText
url(transform:{maxWidth: 400})
}
}
}
variants(first: 1) {
edges {
node {
id
title
sku
price{
amount
currencyCode
}
quantityAvailable
}
}
}
}
}
}
`;

fetch(`${shopifyDomain}/api/2023-04/graphql.json`, {
method: 'POST',
headers: {
'Content-Type': 'application/json',
'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
},
body: JSON.stringify({
query,
variables: {
ids: productIds,
},
}),
})
.then((response) => response.json())
.then((data) => {
const sortedProducts = data.data.nodes.sort((a, b) => {
const aStock = a.variants.edges[0].node.quantityAvailable > 0 ? 1 : 0;
const bStock = b.variants.edges[0].node.quantityAvailable > 0 ? 1 : 0;
// console.log('Sorted By Stock');
return bStock - aStock;
});

sortedProducts.forEach((product) => {
let includeProduct = true;
const productId = product.id;
const productTitle = product.title;
const productSku = product.handle;
const productType = product.productType;
const productVendor = product.vendor;
const productImage = product.images.edges[0].node.url
? product.images.edges[0].node.url
: 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?format=jpg&quality=90&v=1530129081';
const bladeSize = product.blade_size ? product.blade_size.value : '';
const productLink = `/products/${product.handle}`;

const filterMappings = {
fixed_point: ['Fitment Type__Fix point', 'Fitment Type_Fix point'],
flush_rails: ['Fitment Type__Flush Rails', 'Fitment Type_Flush Rails'],
normal: ['Fitment Type__Normal Roof', 'Fitment Type_Normal Roof'],
raised_rails: ['Fitment Type__Railing', 'Fitment Type_Railing'],
};

const mappedFilters = filterMappings[typeFilter] || [];
console.log('Mapped Filters: ' + mappedFilters);
console.log('Product Tags: ' + product.tags);

const productTags = product.tags;

if (mappedFilters.length > 0) {
const anyMappedFilterIncluded = mappedFilters.some((mappedFilter) => productTags.includes(mappedFilter));
if (!anyMappedFilterIncluded) {
includeProduct = false;
}
}

console.log('Include Product: ' + includeProduct);

product.variants.edges.forEach((variantEdge) => {
const variant = variantEdge.node;
const originalPrice = variant.price.amount;
const currencyCode = variant.price.currencyCode;
const currencySymbol = getCurrencySymbol(currencyCode);
const variantID = variant.id;
const variantIdShort = variantID.substring(29);
const quantityAvailable = variant.quantityAvailable;
//check if variant is available and set a variable to use in the if statement
const variantAvailable = quantityAvailable > 0 ? true : false;

// You will need to ensure these product properties are correctly assigned from your product data
const productPrice = originalPrice;
let stockLevelText = quantityAvailable > 0 ? 'In stock' : 'Out of stock';
let stockLevelClass =
quantityAvailable === 0
? 'product-stock-level--none'
: quantityAvailable > 0 && quantityAvailable < 6
? 'product-stock-level--low'
: 'product-stock-level--high';
let showAddToCart = quantityAvailable > 0 ? '' : 'style="display:none"';
// Construct HTML for each product
if (includeProduct) {
productsHtml += `
<div class="productgrid--item imagestyle--natural productitem--emphasis show-actions--mobile" data-product-item="" data-product-quickshop-url="${productLink}" style="--open-height: 526.2187728881836px;">
  <div class="productitem" data-product-item-content="" data-animation-state="closed">
    <div class="productitem__container">
      <div class="productitem__image-container">
        <a class="productitem--image-link" href="${productLink}" tabindex="-1">
          <figure class="productitem--image" style="--product-grid-item-image-aspect-ratio: 1.0;">
            <img src="${productImage}" alt="${productTitle}" class="productitem--image-primary">
            <span class="visually-hidden">${productTitle}</span>
          </figure>
        </a>
      </div>
      <div class="productitem--info">
        <div class="price productitem__price ">
          <span class="money" data-price="">${currencySymbol}${productPrice}</span>
        </div>
        <h2 class="productitem--title">
          <a href="${productLink}">${productTitle}</a>
        </h2>
        <span class="productitem--vendor">
                      <a href="/collections/vendors?q=${productVendor}" title="${productVendor}">${productVendor}</a>
                    </span>
        <div class="product-stock-level-wrapper">

                      <span class="
                          product-stock-level
                          ${stockLevelClass}
                          ">
                          <span class="product-stock-level__text">
                            <div class="product-stock-level__badge-text">
                              ${stockLevelText}
                            </div>
                          </span>
                      </span>
        </div>
      </div>
      <product-form ${showAddToCart}>
        <form method="post" action="/cart/add" id="quick-add-template--${variantIdShort}__product-grid" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
          <input type="hidden" name="form_type" value="product">
          <input type="hidden" name="utf8" value="✓">
          <input type="hidden" name="id" value="${variantIdShort}">
          <button class="productitem--action-trigger productitem--action-atc button-primary" type="submit" aria-label="Add to cart">
            <span class="atc-button--text">Add to cart</span>
          </button>
        </form>
      </product-form>

    </div>
    <script type="application/json" data-quick-buy-settings="">
      {
        "cart_redirection": true,
        "money_format": "${currencySymbol}${productPrice}"
      }
    </script>
  </div>
</div>
`;
}
});
});
if (productsHtml === '') {
productsHtml = `
<div class="loading-overlay gradient"></div>
<div class="title-wrapper center">
  <h2 class="title title--primary">Sorry we have no parts to fit your vehicle</h2>
</div>
`;
}
filteredProductGrid.innerHTML = productsHtml;

//check if regResult is in local storage and if so set the variables below
if (localStorage.getItem('regResult') !== null) {
const yourVehicleJSON = localStorage.getItem('regResult');
const yourVehicle = JSON.parse(yourVehicleJSON);
const yourReg = yourVehicle.reg;
const yourMake = yourVehicle.make;
const yourModel = yourVehicle.model;
const yourBody = yourVehicle.body;
const yourFuel = yourVehicle.fuel_type;

const yourVehicleHTML = `<div class="inner">
  <h1>Your vehicle</h1>
  <div class="icon-reg">
    <div class="your-vehicle__icon">
      <img src=https://cdn.shopify.com/s/files/1/0715/0823/0446/files/hatchback.png?v=1682352677" alt="" srcset="">
    </div>
    <div class="your-vehicle__reg">${yourReg}</div>
  </div>
  <div class="your-vehicle__details">
    <h3>${yourMake} ${yourModel} ${yourBody}</h3>
  </div>
  <div class="your-vehicle__buttons vehicle-confirm__buttons">
    <a href="/pages/find-roof-bars" class="button button--primary">Change my vehicle</a>
  </div>
</div>`;
yourVehicleDiv.innerHTML = yourVehicleHTML;
} else if (localStorage.getItem('manual_selected_options') !== null) {
const yourVehicleJSON = localStorage.getItem('manual_selected_options');
const yourVehicle = JSON.parse(yourVehicleJSON);
const yourMake = yourVehicle.make;
const yourModel = yourVehicle.model;
const yourBody = yourVehicle.bodyStyle;
const yourDateRange = yourVehicle.dateRange;
let yourFuel = '';

if (yourVehicle.fuelType !== '0') {
yourFuel = yourVehicle.fuelType;
}
const yourVehicleHTML = `<div class="inner">
  <h1>Your vehicle</h1>
  <div class="icon-reg">
    <div class="your-vehicle__icon">
      <img src=https://cdn.shopify.com/s/files/1/0715/0823/0446/files/hatchback.png?v=1682352677" alt="" srcset="">
    </div>
  </div>
  <div class="your-vehicle__details">
    <h3>${yourMake} ${yourModel} ${yourBody} </h3>
    <h3>${yourDateRange}</h3>
    <h3>${yourFuel}</h3>
  </div>
  <div class="your-vehicle__buttons vehicle-confirm__buttons">
    <a href="/pages/find-roof-bars" class="button button--primary">Change my vehicle</a>
  </div>
</div>`;
yourVehicleDiv.innerHTML = yourVehicleHTML;
}
})
.catch((error) => {
console.error('Error fetching products:', error);
});
});

  } catch(e) { console.error(e); }
})();
})();
